import React from 'react';
import { useRecoilState } from 'recoil';

import { rightsidePanel_isOpen } from './RightPanel.state';
import RightSidePanel from './RightSidePanel';
import { TabKeys } from '../../types';

interface IRightPanel {
  onExcelExport: () => void;
  onIgnoreOrRestoreAction: (tabName: TabKeys) => void
}

export default function RightPanelContainer({ onExcelExport, onIgnoreOrRestoreAction }: IRightPanel) {
  const [isOpen, setIsOpen] = useRecoilState(rightsidePanel_isOpen);
  return (
    <RightSidePanel
      isOpen={isOpen}
      onCollapse={setIsOpen}
      onExcelExport={onExcelExport}
      onIgnoreOrRestoreAction={onIgnoreOrRestoreAction}
    />
  );
}
